// extracted by mini-css-extract-plugin
export default {"auth-cont":"Auth_auth-cont__KDxET","auth-by":"Auth_auth-by__s-hJD","name":"Auth_name__4qD61"};